import { capitalizeAllIfLower } from '@btime/helpers'
import { compose, join, map, prop, propOr } from 'ramda'
import React from 'react'

import { Text } from '../../../../components/presentation/Text'
import { usePlace } from '../_load/PlaceLoader'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import LabelValue from '../../../../components/presentation/LabelValue'
import Separator from '../../../../components/helpers/Separator'
import FieldValuesPresenter from '../../../../containers/fieldValues/FieldValuesPresenter'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

const Level = ({ label, hideArrow }) => {
  if (!label) return false
  return (
    <>
      {!hideArrow && <Icon name="BsArrowRightShort" />}
      <Text>{label}</Text>
    </>
  )
}

const ShowPlaceModal = () => {
  const { t } = useTranslation('listPlaces')
  const place = usePlace()
  const canSeeConfidentialFields = useSessionPermission('seeConfidentialFields')

  const assetsName = compose(
    join(', '), //
    map(compose(capitalizeAllIfLower, prop('name'))),
    propOr([], 'assets')
  )(place)

  const levels = propOr('', 'resume', place).split(' - ')

  const fieldValues = propOr([], 'fieldValues', place)

  return (
    <>
      <Separator weight={2} />

      <LabelValue
        label={t('levels')}
        children={
          <FlexGrid justify="flex-start" gutter={0.2}>
            {levels.map((name, index) => (
              <Level key={index} label={name} hideArrow={index === 0} />
            ))}
          </FlexGrid>
        }
      />

      <Separator weight={4} />

      <FlexCol width="100%" wranOn="small">
        <LabelValue label={t('assets')} children={assetsName} />
      </FlexCol>

      <Separator weight={4} />

      <FieldValuesPresenter fieldValues={fieldValues} hideConfidential={!canSeeConfidentialFields} />
    </>
  )
}

export default ShowPlaceModal
